class VariantChange extends HTMLElement {
    constructor() {
        super();
        this.radioButtons = this.querySelectorAll('input[type="radio"]');
        this.mainProduct = this.closest('.js-product');
        this.variantForm = this.mainProduct?.querySelector('product-form form');

        this.bindEvents();
        this.markAvailability();
    }

    // Strike through option values with no available variant for the current
    // selection of the other options (kept selectable so the sold-out state shows).
    markAvailability() {
        if (!window.VariantAvailability) return;
        const dataEl = this.querySelector('[type="application/json"]');
        if (!dataEl) return;
        let variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
        const groups = Array.from(this.querySelectorAll('fieldset')).map((fs) => {
            const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
            const checked = inputs.find((i) => i.checked);
            return {
                selectedValue: checked ? checked.value : null,
                items: inputs.map((input) => ({
                    value: input.value,
                    el: fs.querySelector('label[for="' + CSS.escape(input.id) + '"]')
                }))
            };
        });
        window.VariantAvailability.apply(variants, groups, '_sold-out');
    }

    bindEvents() {
        if (!this.radioButtons?.length) return;
        this.radioButtons.forEach(input => {
            input.addEventListener('change', () => this.handleVariantChange());
        });
    }

    async handleVariantChange() {
        try {
            this.mainProduct?.querySelector('button[name="add"]')?.classList.add('loading');
            this.updateWishlistBtn();
            this.getSelectedOptions();
            this.getVariantId();
            this.markAvailability();
            this.updateFixedBar();
            this.updateUrl();
            this.updateDocumentTitle();
            this.updateProductGallery();
            await this.updateContent();
        } catch (error) {
            console.error('Error handling variant change:', error);
        }
    }

    getSelectedOptions() {
        this.options = Array.from(this.querySelectorAll('fieldset'))
            .map(fieldset =>
                Array.from(fieldset.querySelectorAll('input'))
                    .find(radio => radio.checked)?.value
            )
            .filter(Boolean);
    }

    getVariantId() {
        const variantData = this.querySelector('[type="application/json"]')?.textContent;
        if (!variantData) return;

        const variants = JSON.parse(variantData);
        this.currentVariant = variants.find(variant =>
            variant.options.every((option, index) =>
                this.options[index] === option
            )
        );
    }
    updateFixedBar(){
        const fixedBar = document.querySelector('.js-fixed-bar');
        if(!fixedBar) return;

        const fixedBarSelect = fixedBar.querySelector('select[name="id"]');
        if(fixedBarSelect && fixedBarSelect.querySelector(`option[value="${this.currentVariant.id}"]`)){
            fixedBarSelect.value = this.currentVariant.id;
        }

        // Sync the fixed-bar thumbnail with the selected variant image
        const image = this.currentVariant?.featured_image;
        const img = fixedBar.querySelector('.product-bar-img img');
        if(image && image.src && img){
            const sep = image.src.indexOf('?') > -1 ? '&' : '?';
            const sized = (w) => image.src + sep + 'width=' + w;
            img.src = sized(360);
            img.srcset = sized(165) + ' 165w, ' + sized(360) + ' 360w, ' + sized(533) + ' 533w';
            if(image.alt){ img.alt = image.alt; }
        }
    }

    updateUrl() {
        if (!this.currentVariant) return;

        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', this.currentVariant.id);
        window.history.replaceState({}, '', url);
    }

    // Append the selected variant to the document title for unique, SEO-friendly
    // titles per variant URL.
    updateDocumentTitle() {
        if (!this.currentVariant) return;
        const base = this.dataset.baseTitle;
        if (!base) return;
        let title = base;
        const variantTitle = this.currentVariant.title;
        if (variantTitle && variantTitle !== 'Default Title') {
            title += ' – ' + variantTitle.replaceAll(' / ', ' - ');
        }
        if (this.dataset.shop) {
            title += ' – ' + this.dataset.shop;
        }
        document.title = title;
    }

    updateProductGallery(){
        if (!this.currentVariant?.featured_media) return;

        const gallerySwiper = this.mainProduct.querySelector('.product-gallery-main-slider ')?.swiper;
        if (!gallerySwiper) return;

        const slideIndex = Array.from(gallerySwiper.slides)
            .findIndex(slide => slide.dataset.mediaId === this.currentVariant.featured_media.id.toString());
        if (slideIndex !== -1) {
            // gallerySwiper.slideTo(slideIndex);
        }

    }

    async updateContent() {
        if (!this.currentVariant || !this.variantForm) return;

        // Update variant ID in form
        this.variantForm.querySelector('input[name="id"]').value = this.currentVariant.id;

        try {
            const url = new URL(this.dataset.url, window.location.origin);
            url.searchParams.set('variant', this.currentVariant.id);
            url.searchParams.set('section_id', this.dataset.section);

            const response = await fetch(url);
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');

            this.updateElements(html);
            this.reinitSliderGallery();
            this.reinitGridGallery();
        } catch (error) {
            console.error('Error updating content:', error);
        } finally {
            this.mainProduct?.querySelector('button[name="add"]')?.classList.remove('loading');
        }
    }

    updateElements(html) {
        const elements = [
            {
                fetch: '[data-product-title]',
                current: '[data-product-title]',
                updateMethod: 'innerHTML'
            },
            {
                fetch: '[data-product-price]',
                current: '[data-product-price]',
                updateMethod: 'innerHTML'
            },
            {
                fetch: '[data-product-sku]',
                current: '[data-product-sku]',
                updateMethod: 'outerHTML'
            },
            {
                fetch: '[data-product-button]',
                current: '[data-product-button]',
                updateMethod: 'outerHTML'
            },
            {
                fetch: '[data-product-status]',
                current: '[data-product-status]',
                updateMethod: 'outerHTML'
            },
            {
                fetch: '[data-product-media]',
                current: '[data-product-media]',
                updateMethod: 'outerHTML'
            },
            {
                fetch: '.quantity-input',
                current: '.quantity-input',
                updateMethod: 'max'
            }
        ];
        const fetchedSpecification = html.querySelector('.js-specification-item');
        const currentSpecification = document.querySelector('.js-specification-item');
        if (fetchedSpecification && currentSpecification) {
            if(fetchedSpecification.classList.contains('hidden')){
                currentSpecification.classList.add('hidden')
            }else{
                currentSpecification.classList.remove('hidden')
            }
            currentSpecification.querySelector('.product-accordion-item-content-inner').innerHTML = fetchedSpecification.querySelector('.product-accordion-item-content-inner').innerHTML;
        }
        elements.forEach(({fetch, current, updateMethod}) => {
            const fetchedElement = html.querySelectorAll(fetch);
            const currentElement = document.querySelectorAll(current);

            fetchedElement.forEach((fetchEl, index) => {

                const currentEl = currentElement[index];
                if (fetchEl && currentEl) {
                    currentEl[updateMethod] = fetchEl[updateMethod];
                }
            });
        });
        // Reset quantity to 1 and refresh +/- button states for the new variant's stock limit
        document.querySelectorAll('.quantity').forEach((quantity) => {
            const input = quantity.querySelector('.quantity-input');
            if (input) input.value = 1;
            if (typeof quantity.refreshQuantityButtons === 'function') {
                quantity.refreshQuantityButtons();
            }
        });
    }
    updateWishlistBtn(){
        document.querySelectorAll('.btn-wish')?.forEach(btn=>{
            btn.classList.remove('swym-added')
            btn.classList.remove('swym-adding')
            btn.classList.remove('swym-removing')
        })
    }
    reinitSliderGallery(){
        var sliderMain = document.querySelector('.js-product-gallery-main-slider');
        if (sliderMain) {
            var sliderTab = document.querySelector('.js-product-gallery-tab-slider');
            var counter = document.querySelector('.product-gallery-counter');
            var thumbs = new Swiper(sliderTab, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 200,
                direction: 'vertical',// freeMode: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                preventClicks: false,
                preventClicksPropagation: false
            });
            var productSlider = new Swiper(sliderMain, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 200,
                navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
                thumbs: {swiper: thumbs},
                breakpoints: {0: {slidesPerView: 1, spaceBetween: 4.5}, 1024: {slidesPerView: 1, spaceBetween: 0}},
                on: {
                    init: function init() {
                        updateSliderCounter(this, counter)
                    }, slideChange: function slideChange() {
                        updateSliderCounter(this, counter);
                        var activeIndex = this.realIndex;
                        var thumbsWrapper = thumbs.wrapperEl;
                        var thumbsSlides = thumbs.slides;
                        var activeSlide = thumbsSlides[activeIndex];
                        if (activeSlide && thumbsWrapper) {
                            var containerHeight = thumbs.el.clientHeight;
                            var slideTop = activeSlide.offsetTop;
                            var slideHeight = activeSlide.offsetHeight;
                            var currentTranslate = thumbs.getTranslate();
                            var targetTranslate = -slideTop;// якщо превʼюшка нижче видимої області — доскролити вниз
                            if (slideTop + slideHeight > -currentTranslate + containerHeight) {
                                targetTranslate = -(slideTop - containerHeight + slideHeight)
                            }// обмежуємо скрол, щоб не виліз за межі (вручну)
                            var maxTranslate = 0;
                            var minTranslate = -(thumbsWrapper.scrollHeight - containerHeight);
                            if (targetTranslate > maxTranslate) targetTranslate = maxTranslate;
                            if (targetTranslate < minTranslate) targetTranslate = minTranslate;
                            thumbs.setTranslate(targetTranslate);
                            thumbs.updateActiveIndex(activeIndex);// щоб коректно активувався слайд
                        }
                    }
                }
            });
            var tabSlides = document.querySelectorAll('.js-product-gallery-tab-slider .swiper-slide');
            tabSlides.forEach(function (slide, index) {
                slide.addEventListener('click', function () {
                    productSlider.slideTo(index)
                })
            });// scrollToVideo(document.querySelector('.product-menu-item[href="#video"]'), ".product-gallery-main-slider", productSlider)
            const slideIndex = Array.from(sliderMain.querySelectorAll('.swiper-slide'))
                .findIndex(slide => slide.hasAttribute('data-initial'));
            if (slideIndex !== -1) {
                productSlider.slideTo(slideIndex);
            }
        }

    }
    reinitGridGallery(){
        var productSwiperMob = null;
        var slider = document.querySelector('.js-product-gallery-slider');
        var counter = document.querySelector('.product-gallery-counter');
        if (window.innerWidth <= 1023) {
            if (slider) {
                if (!productSwiperMob) {
                    productSwiperMob = new Swiper(slider, {
                        loop: false,
                        speed: 300,
                        slidesPerView: 1,
                        spaceBetween: 4.5,
                        navigation: {nextEl: null, prevEl: null},
                        on: {
                            init: function init() {
                                updateSliderCounter(this, counter)
                            }, slideChange: function slideChange() {
                                updateSliderCounter(this, counter)
                            }
                        }
                    })
                }
            }
        } else {
            if (productSwiperMob) {
                productSwiperMob.destroy(true, true);
                productSwiperMob = null
            }
        }
    }
}

customElements.define('option-buttons', VariantChange);

function syncProductSelections() {
    const fixedBarSelect = document.querySelector('.js-fixed-bar select[name="id"]');
    const variantData = document.querySelector('option-buttons [type="application/json"]')?.textContent;

    if (!fixedBarSelect || !variantData) return;

    const variants = JSON.parse(variantData);

    // Handle select change
    fixedBarSelect.addEventListener('change', () => {
        const selectedVariant = variants.find(variant => variant.id.toString() === fixedBarSelect.value);
        if (!selectedVariant) return;

        // Update radio buttons to match selected variant
        selectedVariant.options.forEach((optionValue, index) => {
            const radio = document.querySelector(`option-buttons input[type="radio"][value="${optionValue}"]`);
            if (radio) {
                radio.checked = true;
                radio.dispatchEvent(new Event('change'));
            }
        });
    });
}
syncProductSelections()

function updateSliderCounter(swiper, counter) {
    var currentIndex = swiper.realIndex + 1;
    var totalSlides = swiper.slides.length;
    if (currentIndex === totalSlides) {
        counter.innerHTML = currentIndex + '/' + totalSlides
    } else {
        counter.innerHTML = currentIndex + '/' + totalSlides
    }
}